import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getSubscriptionDetails } from '../../../actions/entitlementsActions';

import SubscriptionTable from './SubscriptionTable';
import CreateSubscription from './CreateSubscription';

class AccountSubscriptions extends Component {
  static propTypes = {
    accountDetail: PropTypes.instanceOf(Object),
    setActivePage: PropTypes.func,
    activePage: PropTypes.string,
    updatedActivePage: PropTypes.func,
    hasAccess: PropTypes.any,
  };

  static defaultProps = {
    activePage: 'SUBSCRIPTIONS',
    accountDetail: {},
    hasAccess: 0,
  };

  state = {
    selectedEntitlement: {},
  };

  handleSubscriptionDetail = entitlement => {
    const { accountDetail } = this.props;
    if (entitlement) {
      getSubscriptionDetails(accountDetail.accountId, entitlement.id).then(
        response => {
          if (response && !response.error) {
            const users = _.isEmpty(response.users)
              ? []
              : _.sortBy(response.users, o => o.firstName);
            this.setState(
              {
                selectedEntitlement: {
                  ...response,
                  users,
                },
              },
              () => {
                this.props.setActivePage('DETAIL');
              }
            );
          } else {
            console.warn('Something went wrong on the Subscription details');
          }
        }
      );
    }
  };

  backToTable = () => {
    this.setState({ selectedEntitlement: {} }, () => {
      this.props.setActivePage('SUBSCRIPTIONS');
    });
  };

  renderContent = () => {
    const { selectedEntitlement } = this.state;
    const { activePage } = this.props;
    const users = _.isEmpty(this.props.accountDetail.users)
      ? []
      : _.sortBy(this.props.accountDetail.users, o => o.firstName);

    const accountDetail = {
      ...this.props.accountDetail,
      users,
    };
    if (activePage === 'SUBSCRIPTIONS') {
      return (
        <div className="accounts-roles-listing">
          {_.isEmpty(accountDetail.entitlements) ? (
            <div className="no-result-message">
              There are no entitlements currently assigned to this account.
            </div>
          ) : (
            <SubscriptionTable
              accountDetail={accountDetail}
              handleSubscriptionDetail={this.handleSubscriptionDetail}
            />
          )}
        </div>
      );
    } else if (activePage === 'DETAIL') {
      return (
        <CreateSubscription
          selectedEntitlement={selectedEntitlement}
          handleBack={this.backToTable}
          accountDetail={accountDetail}
          entitlementUsers={selectedEntitlement.users || []}
          entitlementTeams={selectedEntitlement.teams || []}
          updatedActivePage={this.props.updatedActivePage}
          hasAccess={this.props.hasAccess}
        />
      );
    }
    return null;
  };

  render() {
    return <div className="accounts-roles">{this.renderContent()}</div>;
  }
}

export default AccountSubscriptions;
